import { LOGIN_VERIFY_QUERY } from '../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.dfc.new';
import type { DataFetchingClient } from 'data-fetching-client';
import { getPortalAccountId, getPortalInstanceId } from './utils/metadata';

export function queryLoginVerify({
  client,
  objectId,
}: {
  client: DataFetchingClient;
  objectId?: number;
}) {
  return client.query({
    query: LOGIN_VERIFY_QUERY,
    variables: {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId(),
      objectId,
      tolerateInstanceAccessDenied: true,
    },
  });
}
